import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/metadata authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { flattenUniq } from "./flattenUniq.mjs";
import { validateTypes } from "./validateTypes.mjs";
/** @internal */

function unwrapCalls(mod) {
  return mod.calls ? mod.calls.unwrapOr([]) // V0
  : mod.module ? mod.module.call.functions : [];
}
/** @internal */


function getCallNames(_ref) {
  var modules = _ref.modules;
  return modules.map(function (mod) {
    return unwrapCalls(mod).map(function (_ref2) {
      var args = _ref2.args;
      return args.map(function (arg) {
        return arg.type.toString();
      });
    });
  });
}
/** @internal */


function getConstantNames(_ref3) {
  var modules = _ref3.modules;
  return modules.map(function (_ref4) {
    var constants = _ref4.constants;
    return constants ? constants.map(function (constant) {
      return constant.type.toString();
    }) : [];
  });
}
/** @internal */


function unwrapEvents(events) {
  if (!events) {
    return [];
  }

  return events.unwrapOr([]);
}
/** @internal */


function getEventNames(_ref5) {
  var modules = _ref5.modules,
      outerEvent = _ref5.outerEvent;

  var mapArg = function mapArg(_ref6) {
    var args = _ref6.args;
    return args.map(function (arg) {
      return arg.toString();
    });
  }; // V0


  if (outerEvent) {
    return outerEvent.events.map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          events = _ref8[1];

      return events.map(mapArg);
    });
  } // V1+


  return modules.map(function (_ref9) {
    var events = _ref9.events;
    return unwrapEvents(events).map(mapArg);
  });
}
/** @internal */


function unwrapStorage(storage) {
  if (!storage) {
    return [];
  }

  var data = storage.unwrapOr([]);
  return Array.isArray(data) ? data : data.items || data.functions;
}
/** @internal */


function getStorageNames(_ref10) {
  var modules = _ref10.modules;
  return modules.map(function (_ref11) {
    var storage = _ref11.storage;
    return unwrapStorage(storage).map(function (_ref12) {
      var type = _ref12.type;

      if (type.isDoubleMap && type.asDoubleMap) {
        return [type.asDoubleMap.key1.toString(), type.asDoubleMap.key2.toString(), type.asDoubleMap.value.toString()];
      } else if (type.isMap) {
        return [type.asMap.key.toString(), type.asMap.value.toString()];
      } else {
        return [type.asPlain.toString()];
      }
    });
  });
}
/** @internal */


export function getUniqTypes(registry, meta, throwError) {
  var types = flattenUniq([getCallNames(meta), getConstantNames(meta), getEventNames(meta), getStorageNames(meta)]);
  validateTypes(registry, types, throwError);
  return types;
}